/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useLayoutEffect } from 'react';
import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
import { SiteData, externalLinkProps } from '../../utils/consts';
import { getColor } from '../../styles';
import { useModals } from '../../providers';
import bitvavoImg from '../../assets/images/bitvavo-info-modal.jpg';
import { Button as DefButton } from '../buttons';
import { Text as DefText } from '../texts';

const BitvavoInfoModal = () => {
  const { t } = useTranslation();
  const { data, dispatch } = useModals<'bitvavoInfoModal'>();

  useLayoutEffect(() => {
    dispatch({
      type: 'setWrapperProps',
      payload: {
        modalName: 'bitvavo-info',
        styleType: 'withTopImage',
        topImg: bitvavoImg,
        ...(data?.initialPortfolioModalAfterClose
          ? {
              close: () => {
                dispatch({
                  type: 'setModalContent',
                  payload: {
                    // @ts-ignore
                    name: 'initialPortfolioModal',
                  },
                });
                dispatch({
                  type: 'closeModal',
                });
              },
            }
          : {}),
        alwaysContentScrollbar: true,
      },
    });
  }, [data, dispatch]);

  return (
    <>
      <Title variant={'h1'} id={'bitvavo-info-modal-title'}>
        {t('BITVAVO_INFO_MODAL__title')}
      </Title>
      <Text>{t('BITVAVO_INFO_MODAL__text1')}</Text>
      <SubTitle variant={'h2'}>{t('BITVAVO_INFO_MODAL__subTitle1')}</SubTitle>
      <Text>
        <Trans
          i18nKey={'BITVAVO_INFO_MODAL__text2'}
          components={{
            list: <ul />,
            listItem: <li />,
          }}
        />
      </Text>
      <SubTitle variant={'h2'}>{t('BITVAVO_INFO_MODAL__subTitle2')}</SubTitle>
      <Text>
        <Trans
          i18nKey={'BITVAVO_INFO_MODAL__text3'}
          components={{
            list: <ul />,
            listItem: <li />,
          }}
        />
      </Text>
      <Button href={SiteData.BITVAVO_SIGNUP} {...externalLinkProps}>
        {t('BITVAVO_INFO_MODAL__button')}
      </Button>
    </>
  );
};

export type BitvavoInfoModalData =
  | {
      initialPortfolioModalAfterClose: boolean;
    }
  | undefined;

const Text = styled(DefText)`
  ul {
    padding-left: 0;
    margin: 8px 0 0 15px;
    list-style-position: outside;
  }
`;

const Title = styled(Text)`
  margin-bottom: 12px;
`;

const SubTitle = styled(Text)`
  margin-top: 18px;
`;

const Button = styled(DefButton)`
  width: auto;
  align-self: flex-start;
  margin-top: 20px;
  /*noinspection CssUnusedSymbol*/
  .MuiButton-root {
    padding-left: 32px;
    padding-right: 32px;
    background-color: ${getColor('blueRibbon')};

    &:hover {
      background-color: ${getColor('veniceBlue')};
    }
  }
`;

export { BitvavoInfoModal };
